module.exports = __webpack_public_path__ + "image/Pure_Grip.png";